import RequestAbstract from "./RequestAbstract";

export default class ClientsDetails extends RequestAbstract {
    get link() {
        return this.links.clientsDetails;
    }

    async getData(id) {
        const res = await this.get(this.link + "/" + id);
        return res;
    }
}
